import Icon from './icon'

export const AmuiIcon = Icon

export default Vue => Vue.component(Icon.name, Icon)
